export enum CampaignApiEndpoints {
  MPS_PUT = '/mps/sites/:siteId/campaigns/:campaignId',
  MPS_PUT_WHITELISTED_IPS = '/mps/sites/:siteId/campaigns/:campaignId/whitelisted-ips',
  MPS_POST = '/mps/sites/:siteId/campaigns',
  MPS_RULESET_POST = '/mps/sites/:siteId/campaigns/:campaignId/message-rulesets',
}
